/* global grecaptcha */
FD.Page = (function ($, me) {
    'use strict';

    const child = me.Page || {},
        notify = new Notify();

    child.init = function() {
        // show/hide when Country =/!= United States
        $("#Input_Country").change(function () {
            $("#Input_City").val('').removeClass("text-danger").attr('readonly', $(this).val() == FD.Constant.unitedStatesCode);
            $("#Input_State").val('').attr('readonly', $(this).val() == FD.Constant.unitedStatesCode);
            $("#Input_ZipCode").attr('type', $(this).val() == FD.Constant.unitedStatesCode ? 'number' : 'text').blur();
        });

        // automatically get city/state from ZIP
        $("#Input_ZipCode").blur(function () {
            if ($("#Input_Country").val() != FD.Constant.unitedStatesCode) {
                return;
            }
            if ($("#Input_ZipCode").valid()) {
                const zip = $("#Input_ZipCode").val();

                if (zip) {
                    $.fdAjax({
                        url: FD.Page.cityStateFromZip + '?' + $.param({ zip }),
                        method: "GET",
                        callback: function (result) {
                            if (result.data) {
                                let { city, state } = result.data;

                                if (result.data.error) {
                                    $("input[name$=State]").addClass("text-danger").val(result.data.error.description);
                                    $("input[name$=City]").val('');
                                } else {
                                    city = result.data.city.charAt(0).toUpperCase() + result.data.city.slice(1).toLowerCase();
                                    cityStateUpdate(city, state);
                                }
                            }
                        }
                    });
                    return;
                }
            }
            
            // when the zip is invalid, clear the city, state
            cityStateUpdate();

            function cityStateUpdate(city = "", state = "") {
                $("#Input_City").val(city).removeClass("text-danger").attr('readonly', true);
                $("#Input_State").val(state).attr('readonly', true);
            }
        });
    }

    return child;
}(jQuery, FD));